module.exports = __webpack_public_path__ + "static/img/icon-search-history-2.e145c77.png";